// extracted by mini-css-extract-plugin
module.exports = {"UserPanel":"UserPanel_UserPanel__3Jq1N","avatar":"UserPanel_avatar__3ry_q","info":"UserPanel_info__33FRU","userMenu":"UserPanel_userMenu__1XU3s"};